import { networkCall } from "../../../../../../util/network-call/network-call";

export const AdminActiveCompanyListLoader = async () => {

    const getCompaniesResponse = await networkCall('/companies?deleted=false');

    return { getCompaniesResponse };

};